const requestForm = () => {

    const requestModal = document.querySelector('[data-modal="request"]');
    const requestModalWrapper = requestModal.querySelector('[data-modal="text"]');
    const requestModalCloseBtn = requestModal.querySelector('[data-modal="close-btn"]');

    const sumbitBtn = document.querySelector('[data-request="submit-btn"]');
    const submitBtnText = sumbitBtn.querySelector('.text');
    const submitBtmSvg = sumbitBtn.querySelector('.svg');
    const form = document.getElementById('request-form');

    //modal close btn logic
    requestModalCloseBtn.addEventListener('click', () => {
        //close modal
        requestModal.classList.remove('opened');
        setTimeout(() => {
            requestModal.classList.add('dn');
        }, 401);
    });

    //form logic
    form.addEventListener('submit', async (e) => {
        e.preventDefault();
        e.stopPropagation();

        //change text to loading svg
        submitBtnText.classList.add('dn');
        submitBtmSvg.classList.remove('dn');
    
        //Creating FormData object
        const fData = new FormData(form);
        const fAction = form.getAttribute('action');
    
        //Sending form to server
        const fetchResponse = await fetch(fAction, {
            method: 'POST',
            body: fData
        });
    
        const result = await fetchResponse.json();

        //change loading svg to text
        submitBtnText.classList.remove('dn');
        submitBtmSvg.classList.add('dn');
            
        if (fetchResponse.ok) {

            //activate modal
            requestModalWrapper.innerHTML = result.message;
            requestModal.classList.remove('dn');
            setTimeout(() => {
                requestModal.classList.add('opened');
            }, 1);

            //clear form
            form.reset();
        
        } else {
    
            console.log(result);
    
        }
    
    });

}

export {requestForm};